import { useRef } from 'react';
import { Outlet } from 'react-router';
import useRouteChange from '../hooks/useRouteChange';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import styles from './Layout.module.scss';

function Layout() {
  const mainRef = useRef(null);
  const pathname = useRouteChange(mainRef);

  return (
    <div className={styles.shell}>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <SiteHeader />

      {/* tabIndex={-1} makes this a valid focus target after a route change
          without adding it to the tab order. The key restarts the enter
          animation on every navigation. */}
      <main id="main" ref={mainRef} tabIndex={-1} className={styles.main}>
        <div key={pathname} className={styles.page}>
          <Outlet />
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}

export default Layout;
